import React from 'react';
import { Button } from '../ui/button';
import { Separator } from '../ui/separator';
import { CheckCircle, CreditCard, Loader2 } from 'lucide-react';
import EchelonnementPreview from '../EchelonnementPreview';
import { EcheancierCarte } from '../DocumentSections/EcheancierCarte';

export default function ResultatPayment({ savedSimulation, result, confirmingVirement, handleConfirmVirement, onPlanChange }) {
  const prm = savedSimulation?.parametres_devis || {};
  const montant = savedSimulation?.calcul?.contribution_ht || savedSimulation?.calcul?.prime_ht || result?.contribution_ht || savedSimulation?.paiement?.montant || 0;
  // V36.8 — Montant TTC pour l'option Paiement échelonné. Fallback : HT × 1,085 (TVA DOM 8,5 %)
  const montantTTC = prm.montant_ttc_fige
    || savedSimulation?.calcul?.contribution?.montant_ttc
    || savedSimulation?.calcul?.contribution_ttc
    || savedSimulation?.calcul?.montant_ttc
    || result?.contribution_ttc
    || (montant > 0 ? montant * 1.085 : 0);

  return (
    <div className="bg-blue-50 p-4 rounded-xl border border-blue-200">
      <h4 className="font-semibold text-blue-800 flex items-center gap-2 mb-3">
        <CreditCard className="h-5 w-5" />
        Instructions de virement-DOS-DOMIUM
      </h4>
      <div className="space-y-2 text-sm">
        <div className="flex justify-between">
          <span className="text-gray-600">Montant a virer :</span>
          <span className="font-bold text-blue-800">{montant.toLocaleString('fr-FR')} EUR</span>
        </div>
        <div className="flex justify-between">
          <span className="text-gray-600">Reference de virement :</span>
          <span className="font-mono font-bold text-blue-800">COPPAM-DOS-{savedSimulation.reference}</span>
        </div>
        <Separator className="my-2" />
        <div className="text-xs font-semibold text-blue-600 uppercase mb-1">RIB OBJECTIF SCOP OUTREMER</div>
        <div className="space-y-1">
          <div><strong>Titulaire :</strong> OBJECTIF SCOP OUTREMER</div>
          <div><strong>Banque :</strong> Qonto</div>
          <div><strong>IBAN :</strong> <span className="font-mono">FR76 1695 8000 0182 4755 2649 230</span></div>
          <div><strong>BIC :</strong> <span className="font-mono">QNTOFRP1XXX</span></div>
          <div><strong>Adresse :</strong> Parc d'Activite de la Jaille, 97122 Baie-Mahault</div>
        </div>
      </div>

      {/* Bouton Virement Effectue */}
      {!savedSimulation.paiement_valide && !savedSimulation.recu_contribution_ess && (
        <div className="mt-4 pt-4 border-t border-blue-200">
          <Button
            onClick={() => handleConfirmVirement(savedSimulation.reference)}
            disabled={confirmingVirement}
            className="w-full bg-gradient-to-r from-emerald-600 to-green-600 hover:from-emerald-700 hover:to-green-700 text-white font-semibold py-3 shadow-lg"
          >
            {confirmingVirement ? (
              <><Loader2 className="h-5 w-5 mr-2 animate-spin" />Confirmation en cours...</>
            ) : (
              <><CheckCircle className="h-5 w-5 mr-2" />Proceder au paiement</>
            )}
          </Button>
          <p className="text-xs text-blue-600 mt-2 text-center">
            Cliquez une fois le virement bancaire realise pour generer votre recu de contribution solidaire ESS
          </p>
        </div>
      )}

      {/* Confirmation de paiement recu */}
      {(savedSimulation.paiement_valide || savedSimulation.recu_contribution_ess) && (
        <div className="mt-4 pt-4 border-t border-green-200 bg-green-50 -mx-4 -mb-4 p-4 rounded-b-xl">
          <div className="flex items-center gap-3 text-green-700 mb-3">
            <div className="p-2 bg-green-200 rounded-full">
              <CheckCircle className="h-6 w-6" />
            </div>
            <div>
              <p className="font-bold text-lg">Paiement confirme</p>
              <p className="text-sm text-green-600 italic">Contacter l'administrateur via votre espace</p>
            </div>
          </div>
        </div>
      )}

      {/* V36.8 — Bloc Paiement échelonné (acompte 60 % Qonto + 3 SEPA GoCardless).
          Affiché si TTC > 2500 €. Super Admin peut personnaliser via la modale. */}
      {montantTTC > 0 && (
        <div className="mt-4">
          {prm.echelonnement && <EcheancierCarte ech={prm.echelonnement} docId={savedSimulation?.reference} />}
          <EchelonnementPreview montantTotalEur={montantTTC} onPlanChange={onPlanChange} />
        </div>
      )}
    </div>
  );
}
